import { defaultTo } from 'lodash';
import { getI18n, getWeblabs } from '../../shared/selectors/bootstrapData';

let data;

class BootstrapData {
  static load() {
    if (!data) {
      const dataElement = document.getElementById('__data__');
      if (dataElement !== null) {
        data = JSON.parse(dataElement.innerHTML);
      }
    }
    return data;
  }

  constructor(bootstrapData) {
    // @TODO AUTHOR-6808 - how do we handle missing values?

    const defaultData = {
      account: {
        customerId: '',
      },
      csrftoken: {
        token: '',
      },
    };

    this.data = {
      ...bootstrapData,
      account: defaultTo(bootstrapData.account, defaultData.account),
      csrftoken: defaultTo(bootstrapData.csrftoken, defaultData.csrftoken),
    };
  }

  getState() {
    return {
      csrfToken: defaultTo(this.data.csrftoken.token, ''),
      customerId: defaultTo(this.data.account.customerId, ''),
      i18n: getI18n(this.data),
      domain: this.data.domain,
      weblabs: getWeblabs(this.data),
    };
  }
}

export default BootstrapData;
